import Script from 'next/script';
import type { CSSProperties } from 'react';
import type { ParsedEmbedProps } from 'utils/parseEmbed';

interface Props {
  data: ParsedEmbedProps;
}

const BrandedEmbed = ({ data }: Props) => {
  const {
    wrapperId,
    aspectRatio,
    mobileAspectRatio,
    iframeSrc,
    scriptSrc,
    scriptDomain,
    frameBorder,
    scrolling,
    allowFullScreen,
    title,
    iframeClass,
  } = data;

  if (!aspectRatio || !iframeSrc) return null;

  const divStyle: CSSProperties = {
    border: '0 none',
    height: 0,
    margin: 0,
    padding: `0 0 ${parseFloat(aspectRatio) * 100}%`,
    position: 'relative',
    width: 'auto',
  };

  const iframeStyle: CSSProperties = {
    border: '0 none',
    bottom: 0,
    height: '1px',
    left: 0,
    margin: 0,
    minHeight: '100%',
    minWidth: '100%',
    padding: 0,
    position: 'absolute',
    right: 0,
    top: 0,
    width: '1px',
  };

  return (
    <>
      {scriptSrc && (
        <Script
          src={scriptSrc}
          strategy='beforeInteractive'
          {...(scriptDomain && { 'data-ceros-origin-domains': scriptDomain })}
        />
      )}
      <div
        id={wrapperId}
        data-aspectratio={aspectRatio}
        data-mobile-aspectratio={mobileAspectRatio}
        style={divStyle}
      >
        <iframe
          className={iframeClass}
          src={iframeSrc}
          frameBorder={frameBorder ?? '0'}
          scrolling={scrolling ?? 'no'}
          allowFullScreen={allowFullScreen}
          title={title}
          style={iframeStyle}
        />
      </div>
    </>
  );
};

export default BrandedEmbed;
